<template>
  <i-select :value="value" @input="newValue => $emit('input', newValue)" filterable multiple>
    <i-option value="GRID 2022">GRID 2022</i-option>
    <i-option value="GRID 2021">GRID 2021</i-option>
    <i-option value="GRID 2020">GRID 2020</i-option>
    <i-option value="GRID 2019">GRID 2019</i-option>
    <i-option value="GRID 2018">GRID 2018</i-option>
    <i-option value="GRID 2017">GRID 2017</i-option>
    <i-option value="MYU 2020">MYU 2020</i-option>
    <i-option value="MYU 2019">MYU 2019</i-option>
    <i-option value="MYU 2018">MYU 2018</i-option>
    <i-option value="MYU 2017">MYU 2017</i-option>
  </i-select>
</template>

<script>
export default {
  name: "GroupSelect",
  props: ["value"],
};
</script>
